/* eslint-disable no-console */
const Mockbar = {
    info(...args) {
        console.info("[ROLLBAR INFO]", args);
    },
    log(...args) {
        console.log("[ROLLBAR LOG]", args);
    },
    warn(...args) {
        console.warn("[ROLLBAR LOG]", args);
    },
    error(...args) {
        console.error("[ROLLBAR ERROR]", args);
    },
};
/* eslint-enable */

const rollbar = window.Rollbar ? window.Rollbar : Mockbar;

export default rollbar;

export function rollbarXHRError(msg, e, data = {}) {
    rollbar.error(msg, e, {
        fingerprint: msg,
        statusCode: e.response && e.response.status,
        ...data,
    });
}
